import {combineReducers} from 'redux'
import {
  Dialog as DialogTypes,
  Step as StepTypes,
  Email as EmailTypes,
  Phone as PhoneTypes,
  Address as AddressTypes,
} from './types'

function dialog(state = true, action) {
  switch (action.type) {
    case DialogTypes.SHOW:
      return true
    case DialogTypes.HIDE:
      return false
    default:
      return state
  }
}

function step(state = 0, action) {
  switch (action.type) {
    case StepTypes.GO_TO_STEP:
      return action.step
    case StepTypes.GO_BACK:
      return state > 0 ? state - 1 : state
    default:
      return state
  }
}

function email(state = {
  value: '',
  isChecking: false,
  isCancelled: false,
  error: '',
}, action) {
  switch (action.type) {
    case EmailTypes.START_EMAIL_CHECK:
      return Object.assign({}, state, {
        isChecking: true,
        isCancelled: false,
        error: '',
      })
    case EmailTypes.CANCEL_EMAIL_CHECK:
      return Object.assign({}, state, {
        isChecking: false,
        isCancelled: state.isChecking,
        error: '',
      })
    case EmailTypes.RECEIVE_EMAIL_CHECK:
      return Object.assign({}, state, {
        isChecking: false,
        isCancelled: false,
        error: action.error,
      })
    default:
      return state
  }
}

function phone(state = {
  number: '',
  isCheckingNumber: false,
  isCheckingNumberCancelled: false,
  numberError: '',
  showDialog: false,
  code: '',
  isCheckingCode: false,
  isCheckingCodeCancelled: false,
  codeError: '',
}, action) {
  switch (action.type) {
    case PhoneTypes.CHECK_NUMBER:
      return Object.assign({}, state, {
        isCheckingNumber: true,
        isCheckingNumberCancelled: false,
        numberError: '',
      })
    case PhoneTypes.CANCEL_CHECK_NUMBER:
      return Object.assign({}, state, {
        isCheckingNumber: false,
        isCheckingNumberCancelled: state.isCheckingNumber,
        numberError: '',
      })
    case PhoneTypes.RECEIVE_CHECK_NUMBER:
      return Object.assign({}, state, {
        isCheckingNumber: false,
        isCheckingNumberCancelled: false,
        numberError: action.error,
      })
    case PhoneTypes.OPEN_SMS_CODE_DIALOG:
      return Object.assign({}, state, {
        showDialog: true,
      })
    case PhoneTypes.CLOSE_SMS_CODE_DIALOG:
      return Object.assign({}, state, {
        showDialog: false,
      })

    case PhoneTypes.CHECK_CODE:
      return Object.assign({}, state, {
        isCheckingCode: true,
        isCheckingCodeCancelled: false,
        codeError: '',
      })
    case PhoneTypes.CANCEL_CHECK_CODE:
      return Object.assign({}, state, {
        isCheckingCode: false,
        isCheckingCodeCancelled: state.isCheckingCode,
        codeError: '',
        showDialog: false,
      })
    case PhoneTypes.RECEIVE_CODE_CHECK:
      return Object.assign({}, state, {
        isCheckingCode: false,
        isCheckingCodeCancelled: false,
        codeError: action.error,
      })
    default:
      return state
  }
}

function address(state = {
  value: '',
  isChecking: false,
  isCancelled: false,
  error: '',
}, action) {
  switch (action.type) {
    case AddressTypes.CHECK_ADDRESS:
      return Object.assign({}, state, {
        isChecking: true,
        isCancelled: false,
        error: '',
      })
    case AddressTypes.CANCEL_ADDRESS_CHECK:
      return Object.assign({}, state, {
        isChecking: false,
        isCancelled: state.isChecking,
        error: '',
      })
    case AddressTypes.RECEIVE_ADDRESS_CHECK:
      return Object.assign({}, state, {
        isChecking: false,
        isCancelled: false,
        error: action.error,
      })
    default:
      return state
  }
}

export default combineReducers({dialog, step, email, phone, address})



// WEBPACK FOOTER //
// ./src/sections/firstlogin/reducers.js